<template>
  <Content class="account-status" :title="$t('ACCOUNT.STATUS.TITLE')">
    <AccountExtension />
    <hr class="divider" />
    <AccountReceipts />
  </Content>
</template>

<script>
import layout from '@/mixins/layout';

import Content from '@@/common/layout/Content';
import AccountReceipts from './AccountReceipts';
import AccountExtension from './AccountExtension';

export default {
  name: 'AccountStatus',
  components: { AccountReceipts, AccountExtension, Content },

  mixins: [layout],

  created() {
    this.setPageTitle('SETTINGS');
  },
};
</script>
<style></style>
